// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__btlGR","buttons":"Footer_buttons__2h7lg"};